import React from 'react';
import Icon from "antd/lib/icon";
import Button from "antd/lib/button";

const File = (props) => {
  return (
    <div style={{ display: "flex", color: "white", marginBottom: "15px", justifyContent: "space-between" }}>
      <div>
        <Icon style={{marginRight: "5px"}} type={props.icon} />
        <span style={{fontWeight: "600"}}>{ props.filename }</span>
      </div>

      <div>
        <a href="https://github.com/seanseany/blockchain" rel="noopener noreferrer" target="_blank">
          <Button 
            style={{backgroundColor: "transparent", color: "white"}}
            icon="code"
            type="dashed"
          >
            View on GitHub
          </Button>
        </a>
      </div>
    </div>
  );
};

export default File;


// WEBPACK FOOTER //
// ./src/steps/File.js